import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Sticky from 'react-sticky-el'

import LineSeparator from '../LineSeparator'
import MenuDashboardContainer from '../../containers/MenuDashboardContainer'
import MenuLogout from '../MenuLogout'
import MenuProfileSwap from '../MenuProfileSwap'
import MenuUserInfo from '../MenuUserInfo'
import Row from '../Row'

import * as actions from '../../redux/actions'

const MenuSidebar = () => {

  const dispatch = useDispatch()

  const isAuth = useSelector(state => state.auth.isAuth)
  const permissions = useSelector(state => state.auth.profilePermissions)
  const actualProfile = useSelector(state => state.auth.profileSelected)
  const person = useSelector(state => state.auth.userData)

  const userProps = {
    avatar: isAuth ? person.person_general.picture_url : '',
    email: isAuth ? person.person_general.email : '',
    firstName: isAuth ? person.person_general.first_name : '',
    friendlyUrl: isAuth ? person.person_general.friendly_url : '',
    permissions: isAuth ? permissions : [],
    profiles: isAuth ? person.person_profile_swap : [],
    actualProfile: isAuth ? actualProfile : {},
  }

  const handleSelectProfile = async (profileCode) => {
    await dispatch(actions.authSwap(profileCode))
  }

  const handleLogout = async () => {
    await dispatch(actions.authLogout())
  }

  return (
    <Sticky stickyStyle={{ 'marginTop': '30px' }}>
      <div className='MenuSidebar'>
        <MenuUserInfo {...userProps} />
        {
          userProps.profiles.length > 1 &&
          <Row>
            <MenuProfileSwap
              actualProfile={userProps.actualProfile}
              personProfiles={userProps.profiles ? userProps.profiles : []}
              onClickSelect={handleSelectProfile}
            />
          </Row>
        }
        <MenuDashboardContainer userPermissions={userProps.permissions} />
        <LineSeparator 
          lineMargin='5px 0 10px 0'
          lineHeight='1px'
        />
        <MenuLogout onHandleLogout={handleLogout} />
      </div>
    </Sticky>
  )
}

export default MenuSidebar
